/* eslint-disable react/no-danger */
import React, { type FC } from 'react';
import { withRouter } from 'react-router';
import clsx from 'clsx';
import { FlexBox } from '@is24at/react-ui-core';
import { Image } from '@is24at/react-image';
import { ImagePlaceholder } from 'assets/ImagePlaceholder';
import { type Listing } from 'server/types/graphql';
import BadgeList from '../BadgeList';
import KeyFact, { PriceKeyFact } from '../KeyFact';
import KeyFacts from '../KeyFacts';
import RealtorLogo from '../RealtorLogo';
import styles from './Property.scss';

type Props = Listing & { baseUrl: string; companyName: string };

const Property: FC<Props> = ({
  addressString,
  headline,
  typedBadges,
  primaryPriceKeyFact,
  mainKeyFacts,
  isPrivate,
  primaryPictureImageProps: { src: primaryPictureSrc } = { src: undefined },
  links: { targetURL },
  realtorLogoImageProps: { src: realtorLogoSrc } = { src: undefined },
  baseUrl,
  companyName,
}) => {
  return (
    <FlexBox
      tag="section"
      spacing={0}
      className={clsx(styles.property, 'mb-12')}
      alignItems="normal"
    >
      <a
        className={styles.property__image__link}
        href={`${baseUrl}${targetURL}`}
      >
        {primaryPictureSrc ? (
          <Image
            imageCn={styles.property__image}
            src={primaryPictureSrc}
            alt={headline}
            dimensions={{ width: 500, height: 332 }}
          />
        ) : (
          <ImagePlaceholder />
        )}
      </a>
      <FlexBox
        tag="section"
        direction="column"
        spacing={0}
        alignItems="normal"
        className={clsx(styles.property__info, 'p-12')}
      >
        <p className={styles.property__info__address}>{addressString}</p>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a href={`${baseUrl}${targetURL}`}>
          <h2
            className={styles.property__info__title}
            dangerouslySetInnerHTML={{ __html: headline }}
          />
        </a>
        <BadgeList typedBadges={typedBadges ?? []} />
        <KeyFacts>
          {mainKeyFacts.map((keyFact) => (
            <KeyFact key={`${keyFact.value}-${keyFact.label}`} {...keyFact} />
          ))}
          <PriceKeyFact {...primaryPriceKeyFact} />
        </KeyFacts>
        <div
          className={clsx(styles.property__info__logo, {
            [styles.property_image_logo]: !!realtorLogoSrc,
          })}
        >
          {realtorLogoSrc ? (
            <RealtorLogo src={realtorLogoSrc} alt={`Logo ${companyName}`} />
          ) : (
            <span className={styles.logo__alternative}>
              {isPrivate ? 'Privat' : 'Gewerblich'}
            </span>
          )}
        </div>
      </FlexBox>
    </FlexBox>
  );
};

export default withRouter(Property);
